import mutations from '@monolith/legacy/store/offers/mutations';
import actions from '@monolith/legacy/store/offers/actions';
import getters from '@monolith/legacy/store/offers/getters';
import { BusinessEventPeriode } from '@monolith/legacy/types/business-event';
import { OfferProgramEligibility } from '@monolith/legacy/modules/promote-engage/services/offer';

export { OFFERS_STORE_ID } from './constants';

export interface OffersState {
  events: BusinessEventPeriode[];
  offerEligibility: {
    eligibility: OfferProgramEligibility[];
    eligibilityFetched: boolean;
  };
}

const state: OffersState = {
  events: [],
  offerEligibility: {
    eligibility: [],
    eligibilityFetched: false,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
